import type { FaceFrame } from "./faceRig";

export const PERFORMANCE_LIBRARY = "artisan-1";
export interface DeliveryPattern {
  face: FaceFrame;
  lead: number;
  tail: number;
  cps: number;
  /** One nod on the final word; all angles and timings are authored locally. */
  nod: number;
  look: "listener" | "work";
}
export const NEUTRAL_DELIVERY: DeliveryPattern = {
  face: {}, lead: 0.22, tail: 0.3, cps: 22, nod: 0, look: "listener",
};
const PATTERNS: Record<string, DeliveryPattern> = {
  measured_welcome: { ...NEUTRAL_DELIVERY, face: { browOuterUpRight: 0.13 }, lead: 0.35 },
  restrained_recognition: {
    ...NEUTRAL_DELIVERY, lead: 0.48, tail: 0.46,
    face: { browInnerUp: 0.12, mouthSmileLeft: 0.19, mouthSmileRight: 0.12, eyeSquintLeft: 0.12, eyeSquintRight: 0.12 },
  },
  restrained_acknowledgement: {
    ...NEUTRAL_DELIVERY, lead: 0.16, tail: 0.65, cps: 20, nod: 0.11,
    face: { mouthSmileLeft: 0.26, mouthSmileRight: 0.18, eyeSquintLeft: 0.16, eyeSquintRight: 0.16 },
  },
  explain_craft: {
    ...NEUTRAL_DELIVERY, lead: 0.25, tail: 0.35, cps: 23,
    face: { browDownLeft: 0.1, browDownRight: 0.1 }, look: "work",
  },
  quiet_pride: {
    ...NEUTRAL_DELIVERY, tail: 0.5, nod: 0.065,
    face: { mouthSmileLeft: 0.22, mouthSmileRight: 0.14, browOuterUpRight: 0.12 },
  },
  reserved_farewell: { ...NEUTRAL_DELIVERY, tail: 0.35, nod: 0.055 },
};

export function resolveDelivery(id: string, library: string): { pattern: DeliveryPattern; fallback: boolean } {
  const pattern = library === PERFORMANCE_LIBRARY && Object.hasOwn(PATTERNS, id) ? PATTERNS[id] : undefined;
  return { pattern: pattern ?? NEUTRAL_DELIVERY, fallback: !pattern };
}

export const ARTISAN_LISTENING_FACE: FaceFrame = { browInnerUp: 0.055 };
